module.exports = __webpack_public_path__ + "media/facebook.3ad226f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/templates/outSide/assets/img/facebook.svg
// module id = ./src/templates/outSide/assets/img/facebook.svg
// module chunks = 0